import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, RefreshCw, Smartphone, Wand2, Undo2 } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social-planner`;

const Thumb = ({ q, st }) => (
  <div className="flex h-20 w-[45px] shrink-0 items-center justify-center overflow-hidden rounded bg-zinc-800">
    {st.status === "ready" && st.kind === "video" ? <video src={st.url} muted loop autoPlay playsInline className="h-20 w-[45px] object-cover" data-testid={`queue-story-video-${q.id}`} />
      : st.status === "ready" ? <a href={st.url} target="_blank" rel="noreferrer"><img src={`${st.url}?w=200`} alt="story" className="h-20 w-[45px] object-cover" data-testid={`queue-story-img-${q.id}`} /></a>
        : st.status === "generating" ? <Loader2 className="h-4 w-4 animate-spin text-amber-400" /> : <Smartphone className="h-4 w-4 text-zinc-500" />}
  </div>
);

export const StoryPreview = ({ q, busy, onRegen, reload }) => {
  const st = q.story || {};
  const [edit, setEdit] = useState(false);
  const [instr, setInstr] = useState("");
  const [working, setWorking] = useState("");
  const video = st.kind === "video";
  const label = video ? "Story = video-ul tău" : { ready: "Story gata", generating: "Story în generare…", failed: "Story eșuat" }[st.status] || "Story se face când postarea ajunge printre primele 3";
  const sub = st.status === "failed" ? st.error?.slice(0, 80) : video ? "Se publică exact cum l-ai încărcat · FB + IG Story"
    : st.instruction ? `Rescris: „${st.instruction.slice(0, 50)}”` : q.creative?.own ? "9:16 refăcut de AI din creativul tău · FB + IG Story" : "9:16 refăcut de AI · Facebook + Instagram Story";
  const call = async (k, fn, msg) => {
    setWorking(k);
    try { await fn(); toast.success(msg); setEdit(false); setInstr(""); await reload(); } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setWorking("");
  };
  const off = !!busy || !!working || st.status === "generating" || q.status !== "planned";
  return (
    <div className="mx-4 mb-3 rounded-lg border border-zinc-800 bg-zinc-950/60 p-2" data-testid={`queue-story-${q.id}`}>
      <div className="flex items-center gap-3">
        <Thumb q={q} st={st} />
        <div className="min-w-0 flex-1 text-xs">
          <p className={`font-medium ${st.status === "failed" ? "text-rose-300" : "text-zinc-200"}`} data-testid={`queue-story-status-${q.id}`}>{label}</p>
          <p className="text-zinc-500">{sub}</p>
        </div>
        {!video && <>
          {q.story_prev && <button data-testid={`queue-story-restore-${q.id}`} onClick={() => call("restore", () => axios.post(`${API}/queue/${q.id}/story/restore`), "Story-ul anterior e din nou cel folosit")} disabled={off} title="Revino la Story-ul anterior" className="rounded-full border border-zinc-700 p-1.5 text-zinc-300 hover:border-amber-400 disabled:opacity-40">
            {working === "restore" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Undo2 className="h-3.5 w-3.5" />}</button>}
          <button data-testid={`queue-story-edit-${q.id}`} onClick={() => setEdit(!edit)} disabled={off} title="Rescrie Story-ul cu o instrucțiune" className="rounded-full border border-zinc-700 p-1.5 text-zinc-300 hover:border-amber-400 disabled:opacity-40"><Wand2 className="h-3.5 w-3.5" /></button>
          <button data-testid={`queue-story-regen-${q.id}`} onClick={onRegen} disabled={off} title="Refă Story-ul (~$0.15)" className="rounded-full border border-zinc-700 p-1.5 text-zinc-300 hover:border-amber-400 disabled:opacity-40">
            {busy === "story" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />}</button>
        </>}
      </div>
      {edit && (
        <div className="mt-2 flex gap-2">
          <Input data-testid={`queue-story-instruction-${q.id}`} value={instr} onChange={(e) => setInstr(e.target.value)} placeholder="ex. păstrează doar logo-ul și reducerea" className="h-8 text-xs" />
          <button data-testid={`queue-story-edit-submit-${q.id}`} disabled={!instr.trim() || !!working} onClick={() => call("edit", () => axios.post(`${API}/queue/${q.id}/story/edit`, { instruction: instr }), "Story nou în generare (~1 min, ~$0.15)")} className="shrink-0 rounded-full bg-amber-400 px-3 text-xs font-semibold text-zinc-950 disabled:opacity-50">
            {working === "edit" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Rescrie"}</button>
        </div>
      )}
    </div>
  );
};
